import type ComponentTypes from "~/features/cms/componentTypes";
import { ForkPageNavigation } from "~/features/forkPage/components/ForkPageNavigation";
import type { ForkPageNavigationProps } from "~/features/forkPage/types";

export interface CMSForkPageNavigationProps extends ForkPageNavigationProps {
  type: ComponentTypes.CMSForkPageNavigation;
  id?: string;
  className?: string;
}

export const CMSForkPageNavigation = ({ className, ...props }: CMSForkPageNavigationProps) => {
  return (
    <div className={className}>
      <ForkPageNavigation {...props} />
    </div>
  );
};
